export enum CourseStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DRAFT = 'draft',
  DELETED = 'deleted',
}

export const CourseStatusTextRecord: Record<CourseStatus, string> = {
  [CourseStatus.ACTIVE]: 'Ativo',
  [CourseStatus.INACTIVE]: 'Inativo',
  [CourseStatus.DRAFT]: 'Rascunho',
  [CourseStatus.DELETED]: 'Excluído',
};
